import {Component, Input} from '@angular/core';
import {CommonModule, NgIf} from '@angular/common';
import {style} from "@angular/animations";

@Component({
    selector: 'app-loading-page',
    templateUrl: './loading-page.component.html',
    styleUrls: ['./loading-page.component.scss'],
    imports: [
        NgIf
    ],
    standalone: true
})
export class LoadingPageComponent {
	@Input() style = 'width: 60px'
    @Input() showLabel = false;
}
